/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    INFO: 'info',
    WARN: 'warn',
    REGISTRATION: 'registration',
};
